<template>
    <div>
        <div class="tenant_title">
            房东查询
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="输入查询：">
                <el-input
                    v-model="formInline.searchValue"
                    placeholder="请输入会员名称或电话"
                    clearable
                ></el-input>
            </el-form-item>
            <!-- 选择时间 -->
            <el-form-item label="创建时间：" class="left_margin">
                <el-date-picker
                    v-model="time"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    size="small"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="left"
                    prefix-icon="el-icon-date"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="消费金额：" class="money">
                <el-input
                    v-model="money.moneyMin"
                    placeholder="最低价"
                    clearable
                ></el-input>
                <div class="zhi">至</div>
                <el-input
                    v-model="money.moneyMax"
                    placeholder="最高价"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label="是否认证：" class="left_margin">
                <el-select
                    v-model="formInline.isRealName"
                    clearable
                    placeholder="选择是否实名认证"
                >
                    <el-option
                        v-for="item in isRealNames"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <br/>
            <el-form-item label="房东类型：" class="left_margin">
                <el-select
                    v-model="formInline.landlordType"
                    clearable
                    placeholder="选择房东类型"
                >
                    <el-option
                        v-for="item in landlordTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="left_margin">
                <el-button type="primary" @click="onSubmit" class="inquire"
                >搜索
                </el-button
                >
                <el-button type="primary" class="reset" @click="reset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="newly_built" style="display: inline-flex">
            <el-upload
            class="upload-demo"
            action=""
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="importHourseExcel"
        >
            <el-button
                type="primary"
                style="border: #2f80ed;width: 72px;"
                v-if="premission('Export:Listing:list')"
            >导入
            </el-button>
        </el-upload>
            <el-button
                type="primary"
                class="export"
                @click="handleAdd"
                v-if="premission('Export:landlord')"
            >导出
            </el-button
            >

        </div>

        <!-- 表单区域 -->
        <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="customerId" label="会员编号"></el-table-column>
            <el-table-column prop="nickName" label="会员昵称"></el-table-column>
            <el-table-column prop="customerName" label="真实姓名"></el-table-column>
            <el-table-column prop="phonenumber" label="手机号"></el-table-column>
            <el-table-column prop="city" label="房源城市"></el-table-column>
            <el-table-column prop="createTime" label="注册时间"></el-table-column>
            <el-table-column prop="createBy" label="待上线"></el-table-column>
            <el-table-column prop="isConsumer" label="已上线"></el-table-column>
            <el-table-column prop="isLandlord" label="已下线"></el-table-column>
            <el-table-column prop="landlordType" label="房东类型">
                <template slot-scope="scope">
                    {{ scope.row.landlordType == 1 ? "悠家自营" : "个人房东" }}
                </template>
            </el-table-column>
            <el-table-column prop="source" label="房东来源"></el-table-column>
            <el-table-column prop="cSteward" label="运营管家"></el-table-column>
            <el-table-column prop="moneyIncome" label="总收益"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="details(scope.row)"
                    >查看
                    </el-button
                    >
                </template
                >
            </el-table-column>
        </el-table>
        <!-- <div class="checkBox"></div> -->
        <!-- 分页 -->
        <div class="paging">
            <div class="block">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[8, 16, 24, 32]"
                    :page-size="8"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {money} from "../../utils/treating";
import {getLandlordAjax, importExcel, importLandExcel} from "../../api/index";
import premission from "../../utils/permission";
import {ExportTenant, exportUser} from "@/api/export"

export default {
    mixins: [premission],
    data() {
        return {
            // 时间
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            total: 0,
            currentPage: 1,
            // 消费金额
            money: {
                moneyMin: "",
                moneyMax: ""
            },
            // 搜索条件
            time: [],
            type:{
                landlordType:''
            },
            formInline: {
                landlordType: "",
                isRealName: "",
                pageNum: 1,
                pageSize: 8,
                searchValue: undefined
            },
            tableData: [],
            isRealNames: [
                {
                    value: '0',
                    label: "未实名"
                },
                {
                    value: '1',
                    label: "已实名"
                }
            ],

            landlordTypes: [
                {
                    value: '0',
                    label: "个人房东"
                },
                {
                    value: '1',
                    label: "悠家自营房东"
                }
            ],
            selectData: []
        };
    },
    created() {
        this.LandlordAjaxList();
    },
    methods: {
        handleAdd() {
            var obj = {}
            if (this.selectData.length > 0) {
                obj.landlordVoList = this.selectData
            }
            ExportTenant(obj).then(result => {
                console.log(result)
            })
        },
        onSubmit() {
            this.LandlordAjaxList();
        },
        reset() {
            this.formInline = {
                landlordType: "",
                isRealName: "",
                pageNum: 1,
                pageSize: 8,
                searchValue: undefined
            };
            this.time = [];
            this.money = {
                moneyMin: "",
                moneyMax: ""
            };
            this.LandlordAjaxList();
        },
        // 全选
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 反选
        handleSelectionChange(arr) {
            console.log(arr);
            this.selectData = arr;
        },
        // 获取表单数据
        async LandlordAjaxList() {
            const {data: res} = await getLandlordAjax(
                money(this.formInline, this.money, this.time)
            );
            this.tableData = res.rows;
            this.total = res.total;
        },
        // 分页
        handleSizeChange(val) {
            this.formInline.pageSize = val;
            this.LandlordAjaxList();
        },
        handleCurrentChange(val) {
            this.formInline.pageNum = val;
            this.LandlordAjaxList();
        },
        // 操作
        details(e) {
            this.$router.push({
                name: "landlordDetails", //跳转的路径
                params: {
                    customerId: e.customerId
                }
            });
        },
        //导入
        importHourseExcel(data){
            console.log(data)
            let fromData=new FormData();
            fromData.append("file",data.raw)

            importLandExcel(fromData).then(res=>{
                console.log(res)
                if(res.data.code==0){
                    this.$message.success('导入成功')
                    this.LandlordAjaxList();
                }else {
                    this.$message.error(res.data.msg)
                }

            })
        },
    }
};
</script>

<style lang="less" scoped>
.tenant_title {
    width: 72px;
    height: 24px;
    font-size: 18px;
    line-height: 24px;
    color: #171a1e;
    margin-bottom: 20px;
}

/deep/ .demo-form-inline {
    .el-input__inner {
        width: 220px;
        height: 36px;
        font-size: 14px;
    }

    .left_margin {
        margin-left: 26px;
    }

    .inquire {
        width: 72px;
        height: 36px;
        margin-top: 2px;
        margin-left: -12px;
    }

    .el-button + .el-button {
        margin-left: 24px;
        width: 72px;
        height: 36px;
        background: #f6b439;
        border: 1px solid #f6b439;
    }
}

/deep/ .el-range-separator {
    width: 10%;
}

/deep/ .el-range-editor.el-input__inner {
    float: left;
    margin-top: 2px;
}

/deep/ .el-date-editor .el-range-separator {
    line-height: 28px;
}

.newly_built {
    margin-top: 18px;
    margin-bottom: 20px;

    .newly_built_btn {
        width: 80px;
        background-color: #f6b439;
        border: 1px solid #f6b439;
    }

    .export {
        width: 72px;
    }

    .el-button {
        text-align: center;
        padding: 0;
        height: 36px;
        margin-right: 14px;
    }
}

.money {
    margin-left: 26px;

    /deep/ .el-form-item__content {
        width: 244px;
        padding-top: 3px;
    }

    div {
        float: left;
    }

    .zhi {
        width: 44px;
        text-align: center;
    }

    /deep/ .el-input {
        width: 100px;
    }

    /deep/ .el-input__inner {
        padding-left: 25px;
        float: left;
        width: 100px;
        height: 36px;
    }
}

.checkBox {
    width: 100%;
    height: 50px;
    background: #f2f2f2;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: 0px;
}

.el-form-item:nth-last-child(2) {
    margin-left: 0;
}

.paging {
    margin-top: 40px;
    margin-left: 610px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #f6b439;
}
</style>
